import api, { apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { AProvider } from "src/framework/providers/AProvider";

class PedidosProvider extends AProvider {
    constructor() {
        super("/vendas/pedidos");
    }

    async verificarSubstituicao(codigo_venda: string): Promise<IDataResponse> {
        const response: IDataResponse = await apiNoLoading.get({
            url: `/vendas/pedidos/${codigo_venda}/verificar_substituicao`
        });

        return response;
    }

    async getPedidos(codigo_venda?: string | null | undefined): Promise<IDataResponse> {
        try {
            const response: IDataResponse = await api.get({
                url: `/vendas/pedidos/listar${codigo_venda ? "/" + codigo_venda : ""}`
            });

            return response;
        } catch (error) {
            return {
                data: null,
                message: "Erro ao consultar banco de dados",
                statusCode: 404
            }
        }
    }
}

export { PedidosProvider }